export default "/_next/static/interview-online.svg";